import { render } from "./videoDialog.vue?vue&type=template&id=6f184b1a&scoped=true"
import script from "./videoDialog.vue?vue&type=script&lang=js"
export * from "./videoDialog.vue?vue&type=script&lang=js"

import "./videoDialog.vue?vue&type=style&index=0&id=6f184b1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f184b1a"]])

export default __exports__